import { BUCKET_STYLES } from "./constants";

export const KpiStrip = ({ summary, buckets }) => {
  if (!summary) return null;
  const cells = [
    { id: "markets", label: "Markets Covered", value: summary.markets_covered, sub: "Intelligence profiles live" },
    ...buckets.map((b) => ({
      id: b.id,
      label: b.short_name,
      value: summary.bucket_counts[b.id],
      sub: "markets",
      color: BUCKET_STYLES[b.id]?.color,
    })),
    { id: "readiness", label: "Avg MAI Readiness", value: `${summary.avg_readiness}`, sub: "of 100 across region" },
  ];
  return (
    <div data-testid="kpi-strip" className="grid grid-cols-2 md:grid-cols-5 border border-slate-200 bg-white divide-x divide-y md:divide-y-0 divide-slate-200">
      {cells.map((c, i) => (
        <div key={c.id} data-testid={`kpi-${c.id}`} className="p-6 stagger-in" style={{ animationDelay: `${i * 60}ms` }}>
          <p className="overline-label text-slate-400">{c.label}</p>
          <p className="font-heading font-extrabold text-4xl tracking-tight mt-3" style={c.color ? { color: c.color } : undefined}>
            {c.value}
          </p>
          <p className="text-xs text-slate-500 mt-1">{c.sub}</p>
        </div>
      ))}
    </div>
  );
};
